// Envio gratis desde $90.000: popup, barra dentro del carrito y 3 recomendados en el carrito.
(function(){
  var GOAL=9000000; // $90.000 en centavos
  // Productos a recomendar, en orden. Vacio = usa los productos activos de la tienda.
  var HANDLES=[];
  var pop=document.getElementById('cdbShipPop');
  if(!pop) return;
  var msg=pop.querySelector('.cdb-ship-msg'), bar=pop.querySelector('.cdb-ship-bar span'), hideT, checkT, raf, total=0, inCart=[], recList=[];
  function fmt(c){ return '$'+Math.ceil(c/100).toLocaleString('es-AR'); }
  function text(){
    var left=GOAL-total;
    return left>0
      ? 'Te faltan <strong>'+fmt(left)+'</strong> para tener <strong>ENVÍO GRATIS</strong>'
      : '¡Listo! Ya tenés <strong>ENVÍO GRATIS</strong> 🎉';
  }
  function pct(){ return Math.min(100,total/GOAL*100)+'%'; }
  function hide(){ pop.classList.remove('is-on'); }
  function showPop(){
    if(!total) return; // carrito vacio: no mostrar
    msg.innerHTML=text();
    bar.style.width=pct();
    pop.classList.add('is-on');
    clearTimeout(hideT);
    hideT=setTimeout(hide,7000);
  }
  // Barra fija dentro del carrito (panel lateral y pagina /cart), arriba del total
  function paintCart(){
    document.querySelectorAll('.cart-totals').forEach(function(el){
      var box=el.previousElementSibling;
      if(!box||!box.classList.contains('cdb-ship-cart')){
        box=document.createElement('div');
        box.className='cdb-ship-cart';
        box.innerHTML='<p class="cdb-ship-cart-msg"></p><div class="cdb-ship-cart-bar"><span></span></div>';
        el.parentNode.insertBefore(box,el);
      }
      box.style.display=total?'':'none';
      if(box.dataset.t!==String(total)){
        box.querySelector('.cdb-ship-cart-msg').innerHTML=text();
        box.querySelector('.cdb-ship-cart-bar span').style.width=pct();
        box.dataset.t=String(total);
      }
    });
  }
  // Recomendados debajo de los productos del carrito
  function paintRecs(){
    var picks=recList.filter(function(p){ return inCart.indexOf(p.handle)<0; }).slice(0,3);
    var key=picks.map(function(p){ return p.handle; }).join(',');
    document.querySelectorAll('.cart-items__wrapper').forEach(function(w){
      var box=w.nextElementSibling;
      if(!box||!box.classList.contains('cdb-recs')){
        box=document.createElement('div');
        box.className='cdb-recs';
        w.parentNode.insertBefore(box,w.nextSibling);
      }
      box.style.display=(total&&picks.length)?'':'none';
      if(box.dataset.k===key) return;
      box.dataset.k=key;
      box.innerHTML='<p class="cdb-recs-ttl">Te puede gustar</p><div class="cdb-recs-grid">'+picks.map(function(p){
        var v=p.variants.filter(function(x){ return x.available; })[0];
        var url='/products/'+p.handle;
        var img=p.featured_image ? p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=300' : '';
        return '<div class="cdb-rec"><a href="'+url+'"><img src="'+img+'" alt="" loading="lazy"></a>'
          +'<a class="cdb-rec-t" href="'+url+'">'+p.title+'</a>'
          +'<span class="cdb-rec-p">'+fmt(p.price)+'</span>'
          +'<button type="button" data-v="'+v.id+'">Agregar</button></div>';
      }).join('')+'</div>';
    });
  }
  function paintAll(){ paintCart(); paintRecs(); }
  function check(popup){
    fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        total=c.total_price||0;
        inCart=(c.items||[]).map(function(i){ return i.handle; });
        paintAll();
        if(popup) showPop();
      })
      .catch(function(){});
  }
  function queue(){ clearTimeout(checkT); checkT=setTimeout(function(){ check(true); },400); }
  pop.querySelector('.cdb-ship-x').addEventListener('click',hide);
  document.addEventListener('cart:update',queue);
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.cdb-rec button');
    if(!b) return;
    e.preventDefault();
    b.disabled=true;
    b.textContent='Agregando...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+b.dataset.v,quantity:1}]})})
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(c){
        // avisa al tema para que re-dibuje el carrito y el contador
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:c,sourceId:'cdb-recs',data:{itemCount:c.item_count,source:'cdb-recs'}}}));
      })
      .catch(function(){ b.disabled=false; b.textContent='Agregar'; });
  });
  var origFetch=window.fetch;
  window.fetch=function(){
    var a=arguments, u=String((a[0]&&a[0].url)||a[0]);
    var p=origFetch.apply(this,a);
    if(['/cart/add','/cart/change','/cart/update'].some(function(s){ return u.indexOf(s)>-1; })){
      p.then(queue,function(){});
    }
    return p;
  };
  // el tema re-dibuja el carrito al actualizarse: volver a insertar la barra y los recomendados si desaparecen
  new MutationObserver(function(){ cancelAnimationFrame(raf); raf=requestAnimationFrame(paintAll); }).observe(document.body,{childList:true,subtree:true});
  var load = HANDLES.length
    ? Promise.all(HANDLES.map(function(h){
        return origFetch('/products/'+h+'.js').then(function(r){ return r.ok?r.json():null; }).catch(function(){ return null; });
      }))
    : origFetch('/products.json?limit=12').then(function(r){ return r.json(); }).then(function(d){
        return (d.products||[]).map(function(p){
          return {handle:p.handle, title:p.title, price:Math.round(parseFloat(p.variants[0].price)*100),
            featured_image:p.images[0]&&p.images[0].src,
            available:p.variants.some(function(v){ return v.available; }),
            variants:p.variants.map(function(v){ return {id:v.id, available:v.available}; })};
        });
      });
  load.then(function(list){
    recList=list.filter(function(p){ return p&&p.available; });
    paintAll();
  }).catch(function(){});
  check(false);
  try{
    if(!sessionStorage.getItem('cdbShipSeen')){
      sessionStorage.setItem('cdbShipSeen','1');
      setTimeout(showPop,4000);
    }
  }catch(e){}
})();